export default {
  // 获取专题详细信息
  getSpecialContentById: '/amc/client/getSpecialContentById',
  // 获取专题下的内容分类列表
  getSpecialById: '/amc/client/listContentClassifyBySpecialId',
  // 专题内容列表接口
  getSpecialContentsByClassifyId: '/amc/client/listSpecialContentsByContentClassifyId',
  // 获取专栏详细信息
  getSpecialContentsForColumn: '/amc/client/getSpecialContentsForColumn',
}